import React, { useMemo } from 'react';
import makeStyles from '@mui/styles/makeStyles';
import { AlertColor } from '@mui/material/Alert';
import { useFeatureFlag } from 'modules/common/hooks';
import { useEnabledGroupTypes } from './hooks/useEnabledGroupTypes';
import { useStartEndSettings } from './hooks/useStartEndSettings';
import { StartEndSettingsPage } from './StartEndSettingsPage';
import { StartEndSettingsPageSkeleton } from './StartEndSettingsPageSkeleton';

const useStyles = makeStyles(() => ({
  div: () => ({
    width: '100%'
  })
}));
type StartEndSettingsLandingProps = {
  onClose?: () => void;
  setAlert?: React.Dispatch<React.SetStateAction<boolean>>;
  setSeverity?: React.Dispatch<React.SetStateAction<AlertColor>>;
};
export const StartEndSettingsLanding: React.FC<StartEndSettingsLandingProps> = ({
  onClose,
  setAlert,
  setSeverity
}: StartEndSettingsLandingProps) => {
  const { data, loading } = useEnabledGroupTypes();
  const classes = useStyles();
  const {
    data: settingsData,
    loading: settingsLoading
  } = useStartEndSettings();
  const enabledGroupTypes = useMemo(
    () => data?.enabledGroupTypes?.items || [],
    [data]
  );
  const isTiAutoAcceptUserSettingsEnabled = useFeatureFlag(
    'isTiAutoAcceptUserSettingsEnabled'
  );

  const settings = useMemo(
    () => settingsData?.getStartEndSettings?.settings || [],
    [settingsData]
  );

  if (loading || settingsLoading) {
    return <StartEndSettingsPageSkeleton />;
  }

  return (
    <div
      data-testid="StartEndSetting"
      className={isTiAutoAcceptUserSettingsEnabled ? classes.div : undefined}
    >
      <StartEndSettingsPage
        enabledGroupTypes={enabledGroupTypes}
        settings={settings}
        onClose={onClose}
        setAlert={setAlert}
        setSeverity={setSeverity}
      />
    </div>
  );
};
